jQuery(function ($) {
	let options = {
		root: null,
		rootMargin: "0px",
		threshold: 0,
	};
	let callback = (entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				if(entry.target.classList.contains('cssAnimation')){
					entry.target.classList.add('is-animated')
				} else {
					let delay = entry.target.dataset?.aosDelay || 0;
					$(entry.target).delay(delay).animate({
						opacity: 1
					}, 400);
				}
			}

		});
	};
	let observer = new IntersectionObserver(callback, options);
	$(function() {
		const aosContainer = document.querySelectorAll('.auto-fading-container');
		const animatedOnVisible = document.querySelector('.cssAnimation');
		[...aosContainer].forEach(wrapper => {
			[...wrapper.children].forEach((e, i) => {
				// if (e.getBoundingClientRect()['top'] > $(window).height() && e.getBoundingClientRect()['height'] < $(window).height()) {
					if (e.tagName === 'PICTURE') {
						const img = e.querySelector('img');
						if (!!img) {
							img.dataset.aos = 'fade-up'
							img.dataset.aosDelay = `${((i+1)%10)*75}`
						}
					} else {
						e.dataset.aos = 'fade-up'
						e.dataset.aosDelay = `${((i+1)%10)*75}`
					}
					$(e).fadeTo(0, 0);
				// }
				observer.observe(e);
			});
		});

		observer.observe(animatedOnVisible);

	})
});
